export default "__VITE_ASSET__bvCwPgPU__"